var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHomeStrokeLg = function SvgIconHomeStrokeLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M7 26.143h5.313V39h23.374V26.143H41L24 9 7 26.143z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    strokeWidth: 2,
    d: "M7 26.143h5.313V39h23.374V26.143H41L24 9 7 26.143z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    strokeWidth: 2,
    d: "M20 26v13h8V26h-8z",
    clipRule: "evenodd"
  }));
};
export default SvgIconHomeStrokeLg;